<form #f="ngForm" (ngSubmit)="onSubmit(f)">

  <mat-form-field class="full-width my-4" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Company Name</mat-label>
    <input matInput placeholder="Company Name" [(ngModel)]="user.entity_name" name="entity_name"  type="text" required [matAutocomplete]="entity_name_auto" (keyup)="getEntityNames($event.target.value)" />
    <mat-hint>Search for your company or employer and select them from the list.</mat-hint>
    <mat-autocomplete #entity_name_auto="matAutocomplete">
      <!-- Near matches are labelled rather than presented as results (SC-2507). Without this the user
           cannot tell a company that IS theirs from one that merely looks like it. -->
      <mat-optgroup *ngIf="entityNameSuggestionMode && autoCompletedEntityNames.length" label="Did you mean...">
        <mat-option *ngFor="let autoCompletedEntityName of autoCompletedEntityNames" [value]="autoCompletedEntityName">
          {{ autoCompletedEntityName }}
        </mat-option>
      </mat-optgroup>
      <ng-container *ngIf="!entityNameSuggestionMode">
        <mat-option *ngFor="let autoCompletedEntityName of autoCompletedEntityNames" [value]="autoCompletedEntityName">
          {{ autoCompletedEntityName }}
        </mat-option>
      </ng-container>
    </mat-autocomplete>
  </mat-form-field>

  <!-- The empty result is what drives duplicate accounts, so it is stated plainly instead of showing an
       empty dropdown and letting the user assume their company is not here (SC-2509). -->
  <div class="alert alert-info py-2 px-3 mb-4" *ngIf="entityNameSearched && !autoCompletedEntityNames.length">
    <small>
      We could not find a company matching <b>{{ user.entity_name }}</b>.
      Check the spelling, or try a shorter version of the name. If your employer is genuinely not on
      SiteConnect yet, carry on and we will confirm before creating them.
    </small>
  </div>

  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Full Name</mat-label>
    <input matInput placeholder="Full Name" [(ngModel)]="user.contact_person" name="contact_person" type="text" required />
    <mat-hint>Enter your first and last name here.</mat-hint>
  </mat-form-field>

  <app-phone-input
    [idInput]="mobile_input_id"
    [numberInput]="user.mobile"
    [countryCodeInput]="user.mobile_country_code"
    [dialCodeInput]="user.mobile_dial_code"
    [e164NumberInput]="user.mobile_e164"
    [additionalClassInput]="'compact'"
    (phoneDetailsOutput)="getOutputPhoneDetails($event)"
    [labelInput]="'Mobile Phone Number'"
    [hintInput]="'Enter your mobile number here.'"
    required="true">
  </app-phone-input>

  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Industry</mat-label>
    <mat-select matInput placeholder="Industry" [(ngModel)]="user.industry" name="industry" required>
      <mat-option *ngFor="let industry of industries" [value]="industry.name">
        {{ industry.name }}
      </mat-option>
    </mat-select>
    <mat-hint>Select your industry.</mat-hint>
  </mat-form-field>

  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Job Title</mat-label>
    <mat-select matInput placeholder="Job Title" [(ngModel)]="user.trade" name="trade" required>
      <mat-option *ngFor="let trade of trades" [value]="trade.name">
        {{ trade.name }}
      </mat-option>
    </mat-select>
    <mat-hint>Select your job title.</mat-hint>
  </mat-form-field>

  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Email Address</mat-label>
    <input matInput placeholder="Email Address" [(ngModel)]="user.email" name="email" type="email" required email />
    <mat-hint>Enter your email address here.</mat-hint>
  </mat-form-field>

  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Password</mat-label>
    <input matInput placeholder="Password" [(ngModel)]="user.password" name="password" [type]="passwordFieldType" required />
    <button mat-icon-button matSuffix aria-label="Show/Hide" (click)="togglePasswordVisibility()" type="button">
      <mat-icon>{{ passwordFieldType === 'password' ? 'visibility' : 'visibility_off' }}</mat-icon>
    </button>
    <mat-hint>Enter a your password here.</mat-hint>
  </mat-form-field>

  <app-password-strength-indicator [passwordInput]="user.password" (passwordValidatedOutput)="getOutputPasswordValidated($event)"></app-password-strength-indicator>

  <div class="full-width mb-4">
    <mat-checkbox [(ngModel)]="tos" matInput name="tos" required>
      I agree to the
      <a [href]="utils.getTermsAndConditionsUrl()" target="_blank">{{ utils.getAppName() == 'SetConnect' ? 'EULA' : 'Terms & Conditions' }}</a>
      and
      <a [href]="utils.getPrivacyPolicyUrl()" target="_blank">Privacy Policy</a>.
    </mat-checkbox>
  </div>

  <button type="submit" mat-raised-button [disabled]="!f.valid || inProgress || !passwordValidated || mobile_error_state" color="primary" class="full-width">
    Sign Up
  </button>
</form>
